// FT-216 REQ-10: тексты карточки рекомендации — заголовок (группа, предложение, даты) и обоснование словами
// из чисел сигналов (REQ-07: шаблон i18n, без LLM). Ключи — литералы (dynamicKeys.spec.js: ключи из частей не
// собираем). Цен в обосновании нет — только доли и даты, как в уведомлениях REQ-11.
import { RECOMMENDATION_KINDS } from "@/api/dynamicPricing";
import { priceGroupLabel } from "@/utils/priceGroupLabel";

const PROPOSAL_KEYS = Object.freeze({
  price_change: { up: "dynamic_pricing.rec.price_up", down: "dynamic_pricing.rec.price_down" },
  date_adjustment: { up: "dynamic_pricing.rec.dates_up", down: "dynamic_pricing.rec.dates_down" },
});

// "2026-10-24" → "24.10"
export function formatShortDate(iso) {
  const m = typeof iso === "string" && iso.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return m ? `${m[3]}.${m[2]}` : iso || "";
}

export function formatShortDates(dates) {
  return (dates || []).map(formatShortDate).join(", ");
}

// Доля 0…1 → целые проценты; нет числа — null (фразу не строим).
export function sharePercent(value) {
  if (value == null || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? Math.round(n * 100) : null;
}

export function recommendationGroupLabel(rec, labelOptions) {
  const group = rec.group;
  if (!group) return "";
  if (group.min == null && labelOptions && labelOptions.t) {
    return labelOptions.t("dynamic_pricing.rec.group_n", { id: group.id });
  }
  return priceGroupLabel(group, labelOptions);
}

// «Снизить прайс на 5 %» / «Наценка 5 % на 24.10, 25.10»
export function recommendationProposal(rec, t) {
  const kind = rec.kind === RECOMMENDATION_KINDS.DATE_ADJUSTMENT ? "date_adjustment" : "price_change";
  const key = PROPOSAL_KEYS[kind][rec.direction === "up" ? "up" : "down"];
  const percent = rec.percent == null ? "" : Math.abs(rec.percent);
  return t(key, { percent, dates: formatShortDates(rec.dates) });
}

// Обоснование. Изменение прайса — простой за 60 дней против обычного и загрузка 3–7 дней против обычной;
// поправка — по каждому дню «занято X %, обычно Y %». Нет чисел — пустая строка.
export function recommendationReason(rec, t) {
  const s = rec.signals;
  if (!s) return "";
  if (rec.kind === RECOMMENDATION_KINDS.DATE_ADJUSTMENT) {
    const days = Array.isArray(s.days) ? s.days : [];
    return days
      .map((d) => ({ date: formatShortDate(d.date), f: sharePercent(d.f), f_hat: sharePercent(d.f_hat) }))
      .filter((d) => d.f != null && d.f_hat != null)
      .map((d) => t("dynamic_pricing.rec.reason_day", d))
      .join("; ");
  }
  const parts = [];
  const u = sharePercent(s.u);
  const uHat = sharePercent(s.u_hat);
  if (u != null && uHat != null) parts.push(t("dynamic_pricing.rec.reason_idle", { u, u_hat: uHat }));
  const f = sharePercent(s.window_f);
  const fHat = sharePercent(s.window_f_hat);
  if (f != null && fHat != null) parts.push(t("dynamic_pricing.rec.reason_window", { f, f_hat: fHat }));
  return parts.join(" ");
}
